import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import api from '../../services/api';
import { recordClientAction } from './clientUiAudit';
const uuid = /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
const labels = { pending: 'Pendiente', sending: 'Enviando', awaiting_dian: 'Esperando DIAN', accepted: 'Aceptado', rejected: 'Rechazado', unknown: 'Resultado incierto: requiere revision' };
export default function PayrollBatchPanel({ base, sourceId, testSetId = '', configuration, companyName, sourceName, onBusy }) {
  const [batch, setBatch] = useState(null); const [busy, setBusy] = useState(true);
  const [error, setError] = useState(''); const [confirmOpen, setConfirmOpen] = useState(false);
  const [running, setRunning] = useState(false); const [steps, setSteps] = useState(0);
  const audit = action => recordClientAction(base.split('/').pop(), { screen: 'payroll', sourceId }, action);
  const stopped = batch?.items.some(i => ['rejected', 'unknown'].includes(i.state));
  const complete = batch?.items.length > 0 && batch.items.every(i => i.state === 'accepted');
  useEffect(() => { onBusy?.(busy || (running && !stopped && !complete && steps < 40)); return () => onBusy?.(false); }, [busy, running, stopped, complete, steps, onBusy]);
  const request = async action => {
    const r = await api.post(`${base}/payroll-batch`, { sourceId, action, batchId: batch?.id, confirm: action === 'batch-step', testSetId: testSetId.trim() }, { timeout: 190000 });
    setBatch(r.data.batch); return r.data.batch;
  };
  const status = async () => {
    setBusy(true); setError('');
    try { await request('batch-status'); } catch (e) { setError(e.response?.data?.message || 'No se pudo consultar el avance.'); }
    finally { setBusy(false); }
  };
  useEffect(() => { status();
    // Opening or selecting an API never sends documents.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const prepare = async () => {
    setBusy(true); setError('');
    try { await audit('button'); if (!batch?.confirmed) await request('prepare-batch'); setConfirmOpen(true); }
    catch (e) { setError(e.response?.data?.message || 'No fue posible preparar las pruebas. No se enviaron documentos.'); }
    finally { setBusy(false); }
  };
  const step = async () => {
    setBusy(true); setError('');
    try { await request('batch-step'); setSteps(n => n + 1); }
    catch (e) { setRunning(false); setError(e.response?.data?.message || 'Resultado no confirmado. Actualice el estado antes de continuar.'); }
    finally { setBusy(false); }
  };
  useEffect(() => {
    if (!running || busy || stopped || complete || steps >= 40) return undefined;
    const timer = setTimeout(step, 16000); return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [running, busy, batch, steps, stopped, complete]);
  const confirm = async () => {
    setBusy(true);
    try { await audit('confirm'); setConfirmOpen(false); setSteps(0); setRunning(true); await step(); }
    catch (_) { setError('No fue posible registrar la confirmacion. No se enviaron documentos.'); setBusy(false); }
  };
  return <Box mt={2}>
    {error && <Alert severity="error">{error}</Alert>}
    <Button size="large" color="primary" variant="contained" disabled={busy || running || stopped || complete || !configuration?.executionEnabled || !configuration?.payrollConfigured || (!batch?.confirmed && !uuid.test(testSetId.trim()))} onClick={prepare}>
      {batch?.confirmed ? 'Continuar pruebas de nomina' : 'Ejecutar pruebas de nomina'}
    </Button>
    {busy && <><LinearProgress /><Typography role="status">Espere un momento, por favor...</Typography></>}
    {running && <Button onClick={() => setRunning(false)}>Pausar pruebas</Button>}
    {batch && <Box mt={2}>
      <Typography>{batch.items.filter(i => i.state === 'accepted').length} de {batch.items.length} documentos aceptados por DIAN.</Typography>
      {complete && <Alert severity="success">Pruebas aceptadas. Confirme el estado final en la DIAN antes de pasar nomina a produccion.</Alert>}
      {stopped && <Alert severity="warning">Las pruebas se detuvieron. No se repetiran envios inciertos o rechazados.</Alert>}
      {steps >= 40 && <Alert severity="info">Se pauso el seguimiento automatico. Actualice el estado para revisar el avance.</Alert>}
      <details><summary>Ver detalle tecnico y avance</summary><Typography variant="caption">Referencia {batch.id}</Typography>
        {batch.items.map(i => <Typography key={`${i.type}-${i.number}`}>{i.prefix}{i.number}: {labels[i.state]} {i.message || ''}</Typography>)}
      </details><Button disabled={busy || running} onClick={status}>Actualizar estado de las pruebas</Button>
    </Box>}
    <Dialog open={confirmOpen} onClose={busy ? undefined : () => setConfirmOpen(false)}>
      <DialogTitle>Confirmar pruebas de nomina</DialogTitle><DialogContent>
        <Typography><strong>{companyName}</strong> · {sourceName}</Typography>
        <Alert severity="warning">Se enviaran documentos sinteticos a la DIAN en habilitacion. No se cambia la facturacion ni se envian correos.</Alert>
        <Typography>Los prefijos y consecutivos disponibles se seleccionaron automaticamente. Cerrar la ventana pausa los pasos siguientes, no un envio que ya este en curso.</Typography>
      </DialogContent><DialogActions><Button disabled={busy} onClick={() => { setConfirmOpen(false); audit('cancel').catch(() => undefined); }}>Cancelar</Button>
        <Button disabled={busy} color="primary" variant="contained" onClick={confirm}>Confirmar y enviar pruebas</Button></DialogActions>
    </Dialog>
  </Box>;
}
